/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/button-has-type */
/* eslint-disable prefer-destructuring */
import 'flatpickr/dist/flatpickr.min.css';
import dayjs from 'dayjs';
import Flatpickr from 'react-flatpickr';
import { Portuguese } from 'flatpickr/dist/l10n/pt';

import { Tooltip } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { ButtonStyles, ContainerStyles } from './styles';

interface InputRangeProps {
  rangeDate: Date[] | null;
  setRangeDate: (time: Date[] | null) => void;
  setPage: (pageNumber: number) => void;
}

export const InputRange = ({
  rangeDate,
  setRangeDate,
  setPage,
}: InputRangeProps) => {
  const handleRangeDate = (time: Date[]) => {
    if (time.length > 1) {
      const initialDate = dayjs(time[0]).format('YYYY-MM-DD 00:00');
      const finalDate = dayjs(time[1]).format('YYYY-MM-DD 23:59');

      const joinedDate = `${initialDate} / ${finalDate}`;
      setPage(0);
      setRangeDate(time);
    }
  };

  const handleClear = () => {
    setRangeDate(null);
    setPage(0);
  };

  return (
    <ContainerStyles>
      <Flatpickr
        placeholder={dayjs(new Date()).format('DD/MM/YYYY')}
        style={{
          width: '100%',
          padding: '9px',
          height: '53px',
          borderRadius: '4px',
          border: '1px solid #c4c4c4',
          fontWeight: '400',
          fontSize: '15px',
          color: 'rgba(0, 0, 0, 0.87)',
        }}
        value={rangeDate as unknown as undefined}
        is="range"
        options={{
          mode: 'range',
          onChange: handleRangeDate,
          locale: Portuguese,
          enableTime: false,
          dateFormat: 'd/m/Y',
          animate: true,
        }}
      />
      <Tooltip title="Limpar data" arrow placement="top">
        <ButtonStyles onClick={handleClear} className="btn">
          <CloseRounded color="action" />
        </ButtonStyles>
      </Tooltip>
    </ContainerStyles>
  );
};
